import {
  Accordion as AccordionComponent,
  AccordionDetails,
  AccordionSummary,
  makeStyles,
} from '@material-ui/core';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  accordionDetails: {
    flexDirection: 'column',
    paddingTop: ({ isAccordionRequired }) => (isAccordionRequired ? 12 : 0),
    paddingLeft: ({ isAccordionRequired }) => (isAccordionRequired ? 32 : 0),
  },
  summaryContent: {
    display: ({ isAccordionRequired }) => (isAccordionRequired ? 'block' : 'none'),
    fontSize: 16,
    color: theme.palette.primary.contrastText,
  },
  expandIcon: {
    display: ({ isAccordionRequired }) => (isAccordionRequired ? 'block' : 'none'),
    '& svg': {
      width: 24,
      height: 24,
    },
  },
}));

export function SettingsAccordion({
  accordionDetailsRef,
  children,
  isAccordionRequired,
  summary,
  ...props
}) {
  const styles = useStyles({ isAccordionRequired });

  return (
    <AccordionComponent {...props}>
      <AccordionSummary
        classes={{ content: styles.summaryContent, expandIcon: styles.expandIcon }}
        expandIcon={<ExpandMoreIcon />}
      >
        {summary}
      </AccordionSummary>
      <AccordionDetails classes={{ root: styles.accordionDetails }} ref={accordionDetailsRef}>
        {children}
      </AccordionDetails>
    </AccordionComponent>
  );
}
